import { render, staticRenderFns } from "./Copyright.vue?vue&type=template&id=69fb0671&functional=true&"
var script = {}
import style0 from "./Copyright.vue?vue&type=style&index=0&id=69fb0671&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports